import { http, HttpResponse } from 'msw';
import { PlessService } from '../../../app/shared/pless-service.model';
import { ResponseUtils } from '../response-utils';


export const kymw46Handlers = [
  // タグ一覧取得 /kymw46/getTagList
  http.post(PlessService.SERVICE.getTagList.url, async ({ request }) => {
    const req: any = await request.json();
    const reqTagId = req?.data?.parameter?.TagGroupId;
    // if (reqTagId && reqTagId === '00000002') return ResponseUtils.getSysError();
    if (reqTagId && reqTagId === '00000001')
      return HttpResponse.json(getTagListResponse1);
    if (reqTagId && reqTagId === '00000002')
      return HttpResponse.json(getTagListResponse2);
    if (reqTagId && reqTagId === '00000003')
      return HttpResponse.json(getTagListResponse3);
    return HttpResponse.json(getTagListResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // タググループ一覧取得 /kymw46/getTagGroupList
  http.post(PlessService.SERVICE.getTagGroupList.url, async ({ request }) => {
    const req = await request.json();
    return HttpResponse.json(getTagGroupListResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // タグ一覧登録 /kymw46/registTagList
  http.post(PlessService.SERVICE.registTagList.url, async ({ request }) => {
    const req = await request.json();
    return HttpResponse.json(registTagListResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
    // return HttpResponse.json(error0519Response);
    // return HttpResponse.json(error0533Response);
  }),

  // タググループ一覧登録 /kymw46/registTagGroupList
  http.post(
    PlessService.SERVICE.registTagGroupList.url,
    async ({ request }) => {
      const req = await request.json();
      return ResponseUtils.getSuccess();
      // return ResponseUtils.getSysError();
      // return ResponseUtils.getE0100();
      // return ResponseUtils.get500();
      // return HttpResponse.json(error0519Response);
    }
  ),

  // タグPコード設定 /kymw46/setTagPCode
  http.post(PlessService.SERVICE.setTagPCode.url, async ({ request }) => {
    const req = await request.json();
    return HttpResponse.json(setTagPCodeResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
    // return HttpResponse.json(error0521Response);
  }),

  // タグ集約 /kymw46/aggregateTag
  http.post(PlessService.SERVICE.aggregateTag.url, async ({ request }) => {
    const req = await request.json();
    return ResponseUtils.getSuccess();
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
    // return HttpResponse.json(error0533Response);
  }),
];

const getTagListResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [
      {
        TagId: '00000001',
        TagName: 'タグ１',
      },
      {
        TagId: '00000002',
        TagName: 'タグ２',
      },
      {
        TagId: '00000003',
        TagName: 'タグ３',
      },
      {
        TagId: '00000004',
        TagName: 'タグ４',
      },
      {
        TagId: '00000005',
        TagName: 'タグ５',
      },
      {
        TagId: '00000006',
        TagName: 'タグ６',
      },
      {
        TagId: '00000007',
        TagName: 'タグ７',
      },
      {
        TagId: '00000008',
        TagName: 'タグ８',
      },
      {
        TagId: '00000009',
        TagName: 'タグ９',
      },
      {
        TagId: '00000010',
        TagName: 'タグ１０',
      },
      {
        TagId: '00000011',
        TagName: 'タグ１１',
      },
      {
        TagId: '00000012',
        TagName: 'タグ１２',
      },
      {
        TagId: '00000013',
        TagName: 'タグ１３',
      },
    ],
  },
};
const getTagListResponse1 = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [
      {
        TagId: '00000001',
        TagName: 'タグ１',
      },
      {
        TagId: '00000002',
        TagName: 'タグ２',
      },
    ],
  },
};
const getTagListResponse2 = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [
      {
        TagId: '00000002',
        TagName: 'タグ２',
      },
      {
        TagId: '00000003',
        TagName: 'タグ３',
      },
    ],
  },
};
const getTagListResponse3 = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [
      {
        TagId: '00000001',
        TagName: 'タグ１',
      },
      {
        TagId: '00000004',
        TagName: 'タグ４',
      },
      {
        TagId: '00000005',
        TagName: 'タグ５',
      },
    ],
  },
};

const getTagGroupListResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [
      {
        TagGroupId: '00000001',
        TagGroupName: 'タググループ１',
        TagList: [
          {
            TagId: '00000001',
            TagName: 'タグ１',
          },
          {
            TagId: '00000002',
            TagName: 'タグ２',
          },
          {
            TagId: '00000003',
            TagName: 'タグ３',
          },
          {
            TagId: '00000004',
            TagName: 'タグ４',
          },
          {
            TagId: '00000005',
            TagName: 'タグ５',
          },
        ],
      },
      {
        TagGroupId: '00000002',
        TagGroupName: 'タググループ２',
        TagList: [
          {
            TagId: '00000002',
            TagName: 'タグ２',
          },
          {
            TagId: '00000005',
            TagName: 'タグ５',
          },
        ],
      },
      {
        TagGroupId: '00000003',
        TagGroupName: 'タググループ３',
        TagList: [],
      },
      {
        TagGroupId: '00000004',
        TagGroupName: 'タググループ４',
        TagList: [
          {
            TagId: '00000004',
            TagName: 'タグ４',
          },
        ],
      },
      {
        TagGroupId: '00000005',
        TagGroupName: 'タググループ５',
        TagList: [
          {
            TagId: '00000002',
            TagName: 'タグ２',
          },
          {
            TagId: '00000004',
            TagName: 'タグ４',
          },
        ],
      },
    ],
  },
};

const registTagListResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      RegistTags: [{ TagId: '00000001', TagName: '新規登録タグ' }],
    },
  },
};

const setTagPCodeResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      RegistPCodes: ['P0000007'],
    },
  },
};

const error0533Response = {
  status: 'plessError',
  message: '該当するデータがありません',
  errorcode: 'E0533',
  strings: ['商品に関連するタグ'],
};
const error0519Response = {
  status: 'plessError',
  message: '該当するデータがありません',
  errorcode: 'E0519',
  strings: ['変更したタグ名に重複したタグ名'],
};
const error0521Response = {
  status: 'plessError',
  message: '該当するデータがありません',
  errorcode: 'E0521',
  strings: ['Pコードの商品'],
};
